<script lang="ts">
  import { Activity, LoaderCircle, Menu } from '@lucide/svelte';
  import type { ThemePreference } from '../lib/theme';

  export let active: 'home' | 'about';
  export let theme: ThemePreference;
  export let busy = false;
  export let onNavigate: (page: 'home' | 'about') => void;
  export let onTheme: (theme: ThemePreference) => void;

  let open = false;
  let toggleButton: HTMLButtonElement;

  function navigate(page: 'home' | 'about') {
    open = false;
    onNavigate(page);
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key !== 'Escape' || !open) return;
    event.preventDefault();
    open = false;
    toggleButton.focus();
  }
</script>

<svelte:window on:keydown={handleKeydown} />

<nav class="navbar" aria-label="Primary navigation">
  <div class="navbar__header">
    <button bind:this={toggleButton} class="navbar__toggle icon-button" type="button" aria-label="Toggle navigation" aria-expanded={open} on:click={() => open = !open}>
      <Menu size={20} aria-hidden="true" />
    </button>
    <button class="navbar__brand" type="button" on:click={() => navigate('home')}>
      <Activity size={21} strokeWidth={2.2} aria-hidden="true" />
      <span>PQ monitoring and analysis</span>
    </button>
  </div>
  <div class:navbar__content--open={open} class="navbar__content">
    <div class="navbar__links">
      <button class:active={active === 'home'} aria-current={active === 'home' ? 'page' : undefined} type="button" on:click={() => navigate('home')}>Home</button>
      <button class:active={active === 'about'} aria-current={active === 'about' ? 'page' : undefined} type="button" on:click={() => navigate('about')}>About</button>
    </div>
    <label class="theme-control">
      <span>Theme</span>
      <select value={theme} on:change={(event) => onTheme((event.currentTarget as HTMLSelectElement).value as ThemePreference)}>
        <option value="system">System</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </label>
  </div>
  <div class="navbar__status" aria-live="polite" aria-atomic="true">
    {#if busy}
      <span class="navbar__loading" role="status" aria-label="Loading data">
        <LoaderCircle class="loading-icon" size={17} aria-hidden="true" />
        <span class="navbar__loading-label">Loading data…</span>
      </span>
    {/if}
  </div>
</nav>
